import React, { Component } from 'react';
import moment from 'moment';

import CheckingOffensesModel from './CheckingOffensesModel';

import { Row, Col, Card, Spin, message } from 'antd';
import { IncomingMessage } from 'http';

class CheckingOffensesTableExpander extends Component {

    state = {
        data: null
    }

    async componentWillMount() {
        try {
            let offense = await CheckingOffensesModel.get(this.props.recordId);
            for (let attachmentIdx in offense.attachments) {
                let base64 = await CheckingOffensesModel.getAttachment(offense.attachments[attachmentIdx].fileName);
                offense.attachments[attachmentIdx].fileBin = base64;
            }
            this.setState({
                data: offense
            });
        } catch (err) {
            message.error('Detail přestupku se nepodařilo načíst');
        }
    }

    onClickImg(base64Img) {
        let image = new Image();
        image.src = base64Img;

        let imgWidth = image.width;
        let imgHeight = image.height;

        let screenWidth = window.screen.availWidth;
        let screenHeight = window.screen.availHeight;

        let newWindowWidth = (imgWidth > (screenWidth - (screenWidth * 0.1)))
            ? screenWidth - (screenWidth * 0.10)
            : imgWidth + (imgWidth * 0.1);

        let newWindowHeight = (imgHeight > (screenHeight - (screenHeight * 0.1)))
            ? screenHeight - (screenHeight * 0.10)
            : imgHeight + (imgHeight * 0.1);

        let w = window.open(null, '_blank', 'width=' + newWindowWidth + ',height=' + newWindowHeight + ',resizable=1');
        w.document.write(image.outerHTML)
    }

    render() {
        if (this.state.data !== null) {
            return (
                <Row gutter={16}>
                    {this.state.data.attachments.map((child, idx) => {
                        let dataImg = "data:image/jpeg;base64," + child.fileBin;
                        return (
                            <Col span={4} key={idx}>
                                <Card
                                    style={{
                                        cursor: 'pointer'
                                    }}
                                    onClick={() => {
                                        this.onClickImg(dataImg)
                                    }}
                                    cover={
                                        <img
                                            alt={child.fileName}
                                            src={dataImg} />
                                    }>
                                    {child.fileName}
                                </Card>
                            </Col>
                        );
                    })}
                </Row>
            );
        } else {
            return (
                <div style={{
                    textAlign: 'center',
                    borderRadius: '4px',
                    marginBottom: 20,
                    padding: '30 50',
                    margin: '20px 0'
                }} >
                    <Spin />
                </div >
            )
        }

    }
}

export default CheckingOffensesTableExpander;


// WEBPACK FOOTER //
// ./src/components/CheckingOffensesTableExpander.js